module.exports = __webpack_public_path__ + "img/triple-j.80b93335.png";